import React from 'react';

import {
  Accordion,
  AccordionButton,
  AccordionItem,
  AccordionPanel,
  Box,
  Center,
  Checkbox,
  HStack,
  Link,
  Stack,
} from '@chakra-ui/react';
import { map } from 'lodash';
import { customTheme } from 'theme';

import { CustomTooltip } from 'components/DataDisplay/Tooltip/CustomTooltip';
import { QuestionCircleIcon } from 'components/Icons';
import { accordionStyles } from 'containers/Setup/CloudAccounts/CloudAccountWizard/Components/OnboardGcp/styles';

export const gcpPermissionList = [
  {
    label: 'Viewer',
    description: 'View most Google Cloud resources.',
  },
  {
    label: 'Service Account Token Creator',
    description:
      'Impersonate service accounts (create OAuth2 access tokens, sign blobs or JWTs, etc).',
  },
];

export const renderAccordionButton = (
  item,
  isExpanded,
  onClick,
  showHelpIcon = true,
  isDisabled = false,
  setIsChecked = (val: boolean) => {},
  isChecked = false,
) => (
  <AccordionButton {...accordionStyles.button} pb={0} pt={0}>
    <HStack color={isDisabled ? customTheme.colors.gray['200'] : 'primary'}>
      <Box>
        <Center>
          <Checkbox
            size="lg"
            isDisabled={isDisabled}
            isChecked={isChecked}
            onChange={e => setIsChecked(e.target.checked)}
          />
        </Center>
      </Box>
      <HStack
        onClick={e => {
          e.stopPropagation();
          onClick(item);
        }}
      >
        <Box>{item?.label}</Box>
        {showHelpIcon && (
          <Box boxSize={4}>
            <QuestionCircleIcon />
          </Box>
        )}
      </HStack>
    </HStack>
  </AccordionButton>
);

export const renderCopyIcon = (item, copied, setCopied) => (
  <CustomTooltip
    label={item?.copyText === copied ? 'Copied' : item?.tooltip}
    w={40}
    textAlign="center"
  >
    <Box
      boxSize={5}
      onClick={() => {
        !!item?.copyText && navigator.clipboard.writeText(item?.copyText);
        setCopied(item?.copyText);
      }}
      cursor="pointer"
    >
      <Center>{item?.icon}</Center>
    </Box>
  </CustomTooltip>
);

export const renderRequiredSteps = ({
  steps,
  onClickButton,
  copied,
  setCopied,
  isDisabled = false,
  isChecked = false,
  setIsChecked = (val: boolean) => {},
}) => {
  return (
    <Stack>
      <Accordion allowMultiple defaultIndex={[0, 1]}>
        {map(steps, o => (
          <AccordionItem {...accordionStyles.item}>
            {({ isExpanded }) => (
              <>
                {renderAccordionButton(
                  o,
                  isExpanded,
                  onClickButton,
                  true,
                  isDisabled,
                  setIsChecked,
                  isChecked,
                )}
                <AccordionPanel {...accordionStyles.panel}>
                  <Stack pl={8} pt={4} spacing={4}>
                    {map(o.secondary, s => (
                      <HStack position="relative">
                        <Box
                          borderLeft="1px solid"
                          borderBottom="1px solid"
                          borderColor="gray.200"
                          h={10}
                          w={4}
                          position="absolute"
                          bottom="50%"
                        />
                        <HStack
                          pl={6}
                          color={
                            isDisabled
                              ? customTheme.colors.gray['200']
                              : 'inherit'
                          }
                        >
                          <Box>{s.label}</Box>
                          {s?.url ? (
                            <Link href={s?.url} target="_blank">
                              <Box boxSize={5}>
                                <Center>{s?.icon}</Center>
                              </Box>
                            </Link>
                          ) : (
                            renderCopyIcon(s, copied, setCopied)
                          )}
                        </HStack>
                      </HStack>
                    ))}
                  </Stack>
                </AccordionPanel>
              </>
            )}
          </AccordionItem>
        ))}
      </Accordion>
    </Stack>
  );
};
